/*
 * WaWiAuftragEinerQuery.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-05 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { gql } from 'graphql-tag'

import {
  AUFTRAGSPOSITION_FRAGMENT,
  AUFTRAG_FRAGMENT,
  KUNDE_FRAGMENT,
  VERSANDANWEISUNG_FRAGMENT,
  ZUSATZLEISTUNG_FRAGMENT,
  ZUTEILUNG_FRAGMENT,
} from '../../fragments'
import { graphql } from '../../gql/index'

export const AUFTRAGSZUSATZPOS_QUERY = gql`
  query AuftragZusatzPositionen($nr: ID!) {
    entity: hwAuftrag(designator: $nr) {
      id
      zusatzleistungen {
        ...zusatzleistungFragment
      }
    }
  }
  ${ZUSATZLEISTUNG_FRAGMENT}
`

export const AUFTRAGPOS_QUERY = gql`
  query AuftragPositionen($nr: ID!) {
    entity: hwAuftrag(designator: $nr) {
      id
      positionen {
        ...auftragspositionFragment
        item {
          id
          name
          preisResolved {
            designator
            fh
            uvp
            basis_name
          }
        }
        reservierungsabrufe {
          id
          _rev
          guid
          created_at
          updated_at
          reservierungsnr
          posnr
          auftragsnr
          posnr_auftrag
          menge
          artnr
          bartnr
          empfaengernr
        }
      }
      zuteilungen {
        ...zuteilungFragment
      }
    }
  }
  ${AUFTRAGSPOSITION_FRAGMENT}
  ${ZUTEILUNG_FRAGMENT}
`

export const AUFTRAGZUTEILUNG_QUERY = graphql`
  query AuftragZuteilungInfo($nr: ID!) {
    entity: hwAuftrag(designator: $nr) {
      id
      zuteilungen {
        id
        designator
        created_at
        updated_at

        auftragsnr
        posnr_auftrag

        menge
        artnr
        artnr_auftrag

        lager
        komminr
      }
    }
  }
`

export const AUFTRAG_QUERY = gql`
  query Auftrag($nr: ID!) {
    entity: hwAuftrag(designator: $nr) {
      ...auftragFragment
    }
  }
  ${AUFTRAG_FRAGMENT}
`

export const AUFTRAG_ALLE_VERSANDANWEISUNGEN_QUERY = gql`
  query AuftragVersandanweisungen($id: ID!) {
    entity: hwAuftrag(designator: $id) {
      id
      versandanweisungen {
        ...versandanweisungFragment
      }
      versandanweisung {
        ...versandanweisungFragment
      }
    }
  }
  ${VERSANDANWEISUNG_FRAGMENT}
`

export const AUFTRAGSWERT_QUERY = gql`
  query AuftragWert($nr: ID!) {
    entity: hwAuftrag(designator: $nr) {
      id
      kunde {
        ...kundeFragment
      }
      wertBerechnung {
        bestellt {
          warenwert
          fh
          kundenPreis
          summe_netto_betraege
          netto_betrag
          steuer_betrag
          brutto_betrag
          abschlag_betrag
        }
        offen {
          warenwert
          fh
          kundenPreis
          summe_netto_betraege
          netto_betrag
          steuer_betrag
          brutto_betrag
          abschlag_betrag
        }
        geliefert {
          warenwert
          fh
          kundenPreis
          summe_netto_betraege
          netto_betrag
          steuer_betrag
          brutto_betrag
          abschlag_betrag
        }
      }
    }
  }
  ${KUNDE_FRAGMENT}
`
export const AUFTRAG_TEXT_MUTATION = gql`
  mutation AuftragsTextMutation(
    $key: ID!
    $oldRev: String
    $fieldName: String
    $value: String
    $message: String
  ) {
    result: updateHwAuftragString(
      auftragKeyString: $key
      auftragRev: $oldRev
      fieldName: $fieldName
      value: $value
      message: $message
    ) {
      auftrag {
        ...auftragFragment
      }
      success
      message
      oldRev
      newRev
      duration
    }
  }
  ${AUFTRAG_FRAGMENT}
`
export const AUFTRAG_FLOAT_MUTATION = gql`
  mutation AuftragsFloatMutation(
    $key: ID!
    $oldRev: String
    $fieldName: String
    $value: Float
    $message: String
  ) {
    result: updateHwAuftragFloat(
      auftragKeyString: $key
      auftragRev: $oldRev
      fieldName: $fieldName
      value: $value
      message: $message
    ) {
      auftrag {
        ...auftragFragment
      }
      success
      message
      oldRev
      newRev
      duration
    }
  }
  ${AUFTRAG_FRAGMENT}
`
